import { useEffect, useState } from "react";
import {
    Flex,
    Heading,
    Input,
    Button,
    InputGroup,
    Stack,
    InputLeftElement,
    chakra,
    Box,
    Avatar,
    FormControl,
    FormHelperText,
    InputRightElement,
    Container,
    useBreakpointValue,
    HStack,
    Text,
    useColorModeValue,
    FormLabel,
    Checkbox,
    Divider
} from "@chakra-ui/react";
import { Link, Navigate } from "react-router-dom";
import { PasswordField } from "../Login/PasswordField";
import { Logo } from "../../../../assets/Logo";
import { registerWithEmailAndPassword } from "../../services/auth";


const SignUp = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [tenantId, setTenantId] = useState<any>('');

    const handleSubmit = async event => {
        event.preventDefault();
        try {
            setTenantId(await registerWithEmailAndPassword(email, password));
        } catch (error) {
        }
    };

    return (
        <Box maxH={"100vh"} overflow="hidden" bg="gray.100">
            {tenantId && <Navigate to={`/company/${tenantId}/dashboard`} />}
            <Container maxW="lg" py={{ base: '12', md: '24' }} px={{ base: '0', sm: '8' }}>
                <Stack spacing="8">
                    <Stack spacing="6">
                        <Logo />
                        <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
                            <Heading size={useBreakpointValue({ base: 'xs', md: 'sm' })}>
                           Welcome back
                            </Heading>
                            <HStack spacing="1" justify="center">
                                <Text color="muted">Already have an account?</Text>
                                <Link to={"/login"} >
                                    <Text color="blue" fontSize={"0.8em"} fontWeight="bold">
                                        Login
                                    </Text>
                                </Link>
                            </HStack>
                        </Stack>
                    </Stack>
                    <Box
                        bg="white"
                        py={{ base: '0', sm: '8' }}
                        px={{ base: '4', sm: '10' }}
                        // bg={useBreakpointValue({ base: 'transparent', sm: 'bg-surface' })}
                        boxShadow={{ base: 'none', sm: useColorModeValue('md', 'md-dark') }}
                        borderRadius={{ base: 'none', sm: 'xl' }}
                    >
                        <form onSubmit={handleSubmit}>
                            <Stack spacing="6" >
                                <Stack spacing="5">
                                    <FormControl>
                                        <FormLabel htmlFor="email">Email</FormLabel>
                                        <Input id="email" type="email"
                                            onChange={event => setEmail(event.target.value)}
                                        />
                                    </FormControl>
                                    <PasswordField
                                        setpassword={setPassword} />
                                </Stack>
                                <Stack spacing="6">
                                    <Button colorScheme="blue" type="submit">Sign Up</Button>
                                </Stack>
                            </Stack>
                        </form>
                    </Box>
                </Stack>
            </Container>
        </Box>
    );
};

export default SignUp;
